import DateUtils from 'relevant-shared/misc/dateUtils';

export default DateUtils;
